export const GET_MESSAGES = 'GET_MESSAGES'
export const GET_MESSAGES_OK = 'GET_MESSAGES_OK'
export const GET_MESSAGES_ERR = 'GET_MESSAGES_ERR'
export const CREATE_MESSAGE = 'CREATE_MESSAGE'
export const CREATE_MESSAGE_OK = 'CREATE_MESSAGE_OK'
export const CREATE_MESSAGE_ERR = 'CREATE_MESSAGE_ERR'
export const DO_MESSAGES_CLEANUP = 'DO_MESSAGES_CLEANUP'